import { render, staticRenderFns } from "./Arrow2.vue?vue&type=template&id=673a0fc4"
import script from "./Arrow2.vue?vue&type=script&lang=js"
export * from "./Arrow2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports